import {createStore, applyMiddleware} from 'redux';
import rootReducer from '../redux/index';
import ReduxThunk from 'redux-thunk';
import api from '../middleware/api';

const createStoreWithMiddleware = applyMiddleware(ReduxThunk, api)(createStore);

export default function configureStore() {
    return createStoreWithMiddleware(rootReducer);
}